/**
 * SalesIQController — route-aware show/hide for the Zoho SalesIQ chat
 * widget. Mounted once in App.js alongside CookieConsent. Listens to
 * react-router location and calls `$zoho.salesiq.floatbutton.visible(...)`
 * to hide the chat bubble on routes where it would compete with a primary
 * task (statement upload, booking flow).
 *
 * This component does NOT load the SalesIQ script — that's the cookie
 * banner's responsibility (see `utils/marketingScripts.js`). If consent
 * hasn't been granted, the widget never loads and the visibility calls are
 * no-ops (setSalesIQVisible defends against the missing-stub case).
 */
import { useEffect } from "react";
import { setSalesIQVisible } from "@/utils/marketingScripts";

// SalesIQ floater is intentionally hidden site-wide: WhatsApp (+44 1244 955 444)
// is the primary conversational channel and owns the bottom-right corner.
// The widget still loads (consent-gated) so chat can be opened programmatically
// if needed.
export default function SalesIQController() {
  useEffect(() => {
    setSalesIQVisible(false);
  }, []);
  return null;
}
